import { Card } from '@/components/ui/card';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export const VPNBlocked = () => (
  <Card className="max-w-md mx-auto mt-20 p-6 text-center">
    <h1 className="text-xl font-semibold mb-2">Page Not Available</h1>
    <p className="text-muted-foreground mb-4">VPN detection has been removed from the site.</p>
    <Button asChild><Link to="/">Return Home</Link></Button>
  </Card>
);
export default VPNBlocked;
